interface Props {
  size?: number;
  label?: string;
}

export function LoadingSpinner({ size = 18, label }: Props) {
  return (
    <span className="inline-flex items-center gap-2 text-text-muted text-sm">
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        className="animate-spin"
      >
        <circle cx="12" cy="12" r="10" stroke="#E8E4DE" strokeWidth="3" fill="none" />
        <path d="M22 12a10 10 0 0 0-10-10" stroke="#EF9F27" strokeWidth="3" fill="none" strokeLinecap="round" />
      </svg>
      {label}
    </span>
  );
}
